// extracted by mini-css-extract-plugin
export default {"title":"ResponsiblePersonAndIdNum_title__Bv3gG","errorMessage":"ResponsiblePersonAndIdNum_errorMessage__PhBlG"};